var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3 2.1 60.7 0l-2.9 69.9H41.9L39.3 2.1zm10.5 78.1c6.1 0 10.4 4.3 10.4 9.9 0 5.8-4.1 9.9-10.4 9.9-6.1 0-10.4-4.1-10.4-9.9.1-5.7 4.3-9.9 10.4-9.9"
  })));
};
export default SvgWarning;